import {
  V4CustomerLoginUsingAccessToken,
  type Invoice,
  type Userdata,
} from "@be-miniapp/api"
import {
  beUserQueryKeys,
  createUseBeUserData,
} from "@be-miniapp/shared/queries"

import { useLogout } from "@/hooks/use-logout"
import { useClientInfo } from "@/store/client-info"
import { useUserStore } from "@/store/user-session"

interface BeUserData {
  data: Userdata | undefined
  accessToken: string | null
  invoice: Invoice | undefined
  setInvoice: (invoice?: Invoice) => void
}

type BeUserDataSelector<T> = (state: BeUserData) => T

export { beUserQueryKeys }

const useBeUserDataCore = createUseBeUserData({
  loginByAccessToken: () => V4CustomerLoginUsingAccessToken(),
  selectorMode: "return",
})

function useBeUserData(): BeUserData
function useBeUserData<T>(selector: BeUserDataSelector<T>): T
function useBeUserData<T>(selector?: BeUserDataSelector<T>) {
  const logout = useLogout()
  const location = useClientInfo((state) => state.additionals.location)
  const accessToken = useUserStore((state) => state.access_token)
  const invoice = useUserStore((state) => state.invoice)
  const setInvoice = useUserStore((state) => state.setInvoice)

  const params = {
    location,
    accessToken,
    invoice,
    setInvoice,
    onSessionExpired: () => logout(),
  }

  if (selector) return useBeUserDataCore(params, selector)

  return useBeUserDataCore(params)
}

export { useBeUserData }
